<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-row>
            <v-col cols="12">
                <h2 class="mb-5 primary--text">Gerenciamento de Perfis</h2>
            </v-col>
        </v-row>

        <v-layout class="d-flex justify-space-between flex-wrap mb-4">
            <div class="d-flex" style="gap: 14px;">
                <v-btn class="transition" color="primary" rounded @click="adicionarPerfil">
                    <v-icon small style="margin-right: 10px;">add</v-icon>
                    ADICIONAR PERFIL
                </v-btn>
                <v-btn class="transition" color="primary" rounded @click="toggleFiltros">
                    <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                    FILTRAR POR
                    <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                </v-btn>
            </div>
            <div class="d-flex">
                <v-btn color="primary" class="justify-end" @click="exportarExcel">
                    <v-icon left size="18">
                        mdi-file-chart
                    </v-icon>
                    SALVAR RELATÓRIO
                </v-btn>
            </div>
        </v-layout>
        <collapse-transition>
            <m-form ref="filter" v-show="filter_open" class="mt-4 ml-2">
                <v-row>
                    <v-col cols="6" class="mb-4">
                        <v-select label="Perfil Administrativo:" placeholder="Selecione o perfil administrativo" outlined
                                  menu-props="offsetY" hide-details v-model="filters.nome" :items="perfisAdministrativos"
                                  item-text="nome" item-value="nome"
                        />
                    </v-col>
                    <v-col cols="6" class="mb-4">
                        <v-select label="Status:" placeholder="Selecione o status do perfil" outlined
                                  menu-props="offsetY" hide-details v-model="filters.status" :items="status_admin"
                                  item-text="label" item-value="value"
                        />
                    </v-col>
                    <v-col cols="6" class="mb-4">
                        <v-select label="Permissão do perfil:" placeholder="Selecione o tipo de permissão" outlined
                                  menu-props="offsetY" hide-details v-model="filters.permissao" :items="permissao_admin"
                                  item-text="label" item-value="value"
                        />
                    </v-col>
                </v-row>
                <v-row class="justify-space-between mt-4">
                    <v-col cols="6" md="3">
                        <v-btn color="secondary" block @click="limpar">
                            Limpar
                        </v-btn>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-btn color="primary" block @click="filtrar">
                            Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </m-form>
        </collapse-transition>
        <v-row>
            <v-col cols="12">
                <DataTable
                        ref="datatable"
                        url="/painel/backoffice/perfil-administrativo-permissions"
                        class="pt-2"
                        :params="params"
                        :headers="headers"
                        :calculate-widths="true"
                        :filter="filterTable"
                >
                    <template v-slot:items="{item}">
                        <td>
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes"
                                           v-bind="attrs"
                                           style="margin: 10px 0px;
                                           padding: 5px;
                                           min-width: 48px;"
                                           v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <v-list-item-title>Editar</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{ item.nome || '-' }}</td>
                        <td>{{ item.status === null || item.status === undefined ? '-' : (item.status === 1 || item.status === true ? 'Ativo' : 'Inativo') }}</td>
                        <td>{{ item.permissao === null || item.permissao === undefined ? '-' : (item.permissao === 1 || item.permissao === true ? 'Sim' : 'Não') }}</td>
                    </template>
                </DataTable>
            </v-col>
        </v-row>
        <DialogPermissoesPerfilAdministrativo v-model="showDialog"
                                              :schema="dialogSchema"
                                              :checkboxes="permissionCheckboxes"
                                              :is-edit="isEdit"
                                              :perfil="perfilEditando"
                                              @submit="salvarPerfilAdmin"

        />
    </v-container>
</template>

<script>
  import DialogPermissoesPerfilAdministrativo from '@/dialogs/DialogPermissoesPerfilAdministrativo.vue'
  import { AlertTypes } from '@/plugins/alerts_types'
  import { PerfisAdmin, permissaoPerfilAdmin, StatusPerfilAdmin } from '@/plugins/constants'
  import { notification } from '@/plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'PerfilAdmin',
    components: {
      DialogPermissoesPerfilAdministrativo
    },
    data: () => ({
      filterTable: {},
      filter_open: false,
      filters: {
        nome: null,
        status: null,
        permissao: null
      },
      pagination: {
        sortBy: [], descending: []
      },
      isLoading: false,
      showDialog: false,
      isEdit: false,
      perfilEditando: null,
      dialogSchema: [
        {
          type: 'input',
          model: 'nome',
          props: { label: 'Nome do Perfil', maxlength: 255 }
        },
        {
          type: 'select',
          model: 'status',
          props: {
            label: 'Status',
            items: [
              { text: 'Ativo', value: 1 },
              { text: 'Inativo', value: 0 }
            ]
          }
        },
        {
          type: 'select',
          model: 'permissao',
          props: {
            label: 'Permissões',
            items: [
              { text: 'Sim', value: 1 },
              { text: 'Não', value: 0 }
            ]
          }
        }
      ],
      perfisAdministrativos: [],
      status_admin: [
        { label: StatusPerfilAdmin.ATIVO.text, value: StatusPerfilAdmin.ATIVO.value },
        { label: StatusPerfilAdmin.INATIVO.text, value: StatusPerfilAdmin.INATIVO.value }
      ],
      permissao_admin: [
        { label: permissaoPerfilAdmin.SIM.text, value: permissaoPerfilAdmin.SIM.value },
        { label: permissaoPerfilAdmin.NAO.text, value: permissaoPerfilAdmin.NAO.value }
      ],
      permissionCheckboxes: [],
      headers: [
        { text: 'Ações', value: '', sortable: false },
        { text: 'Perfil Administrativo', value: 'nome', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Permissões do Perfil', value: 'permissao', sortable: true }
      ],
      dtFiltro: {}
    }),
    computed: {
      params () {
        return {
          pagination: this.pagination
        }
      }
    },

    async created () {
      await Promise.all([
        this.loadFuncionalidades(),
        this.loadPerfisAdministrativos()
      ])
    },
    methods: {
      toggleFiltros () {
        this.filter_open = !this.filter_open
      },
      async adicionarPerfil () {
        this.isEdit = false
        this.perfilEditando = null
        this.showDialog = true
      },
      async salvarPerfilAdmin (form) {
        this.isLoading = true
        try {
          let response
          if (this.isEdit && this.perfilEditando.id_perfil) {
            response = await this.$http.put(`/painel/backoffice/perfil-administrativo-permissions/${this.perfilEditando.id_perfil}`, {
              nome: form.nome.trim(),
              status: form.status,
              permissao: form.permissao,
              funcionalidades: form.selectedPermissions
            })
          } else {
            response = await this.$http.post('/painel/backoffice/perfil-administrativo-permissions', {
              nome: form.nome.trim(),
              status: form.status,
              permissao: form.permissao,
              funcionalidades: form.selectedPermissions
            })
          }

          if (response.data.success) {
            notification(AlertTypes.SUCCESS, response.data.message)
            this.$refs.datatable.reload()
            this.adicionarPerfil()
            this.loadPerfisAdministrativos()
          }
          this.showDialog = false
        } catch (error) {
          let errorMessage = error.response?.data?.error || error.message
          notification(AlertTypes.ERROR, errorMessage)
        } finally {
          this.isLoading = false
        }
      },
      async editar (item) {
        this.isEdit = true

        this.perfilEditando = {
          ...item,
          selectedPermissions: this.getSelectedPermissionsFromPerfil(item)
        }
        this.showDialog = true
      },
      async loadPerfisAdministrativos () {
        try {
          const response = await this.$http.get('/painel/backoffice/perfis-administrativos')
          this.perfisAdministrativos = (response.data || []).filter(perfil => perfil.id_perfil !== PerfisAdmin.Sem_Acesso.id_banco)
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar perfis administrativos: ' + (error.response?.data?.error || error.message))
        }
      },
      async loadFuncionalidades () {
        try {
          const response = await this.$http.get('/painel/backoffice/todas-funcionalidades-perfil')

          const funcionalidades = response.data.items || response.data

          this.permissionCheckboxes = funcionalidades.map(item => ({
            label: item.nome,
            value: item.id_funcionalidade
          }))
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar funcionalidades: ' + (error.response?.data?.error || error.message))
          this.permissionCheckboxes = []
        }
      },
      getSelectedPermissionsFromPerfil (perfil) {
        return (perfil.permissoes_perfil_administrativo_funcionalidades || [])
          .filter(f => f.permitido)
          .map(f => f.id_funcionalidade)
      },
      exportarExcel () {
        const filtros = { ...this.filters }
        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/perfis_administrativos/exportar?${encoded_params}`)
      },
      filtrar () {
        this.filterTable = { ...this.filters }
      },
      limpar () {
        this.filters = {
          nome: null,
          status: null,
          permissao: null
        }
        this.filtrar()
        this.filter_open = false
      }

    }
  }
</script>

<style scoped>
.acoes-header {
    margin-left: 10px !important;
}

.v-btn.transition {
    transition: all 0.3s ease;
}

.v-btn.transition:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

::v-deep th:first-child {
  max-width: 100px;
  padding-left: 15px;
}
</style>
